import { __rest } from 'tslib';

const extractPaddingProps = (props) => {
    const { padding, pt, pr, pb, pl } = props, rest = __rest(props, ["padding", "pt", "pr", "pb", "pl"]);
    return {
        $padding: padding,
        $paddingTop: pt,
        $paddingRight: pr,
        $paddingBottom: pb,
        $paddingLeft: pl,
        rest,
    };
};

export { extractPaddingProps };
//# sourceMappingURL=extractPaddingProps.js.map
